import Link from 'components/shared/Link/Link';

// These SVGs must be imported as components to work on enterprise subdomains
import FacebookIcon from '../../public/icons/facebook.svg';
import InstagramIcon from '../../public/icons/instagram.svg';
import TwitterIcon from '../../public/icons/twitter.svg';
import DownloadAppStore from '../../public/buttons/download-app-store.svg';
import DownloadGooglePlay from '../../public/buttons/download-google-play.svg';
import { LinkTargets } from 'types/constants';

const FooterColumnSocial = () => {
  return (
    <div
      className="flex flex-col gap-6 border-t sm:border-t-0 border-accent-green-600 pt-9 sm:pt-0 sm:w-full"
      data-testid="footerSocialCol">
      <div className="flex flex-col gap-2 sm:w-full w-1/2">
        <Link
          href="https://apps.apple.com/us/app/chime-banking/id836215269"
          target={LinkTargets.NewTab}
          className="w-full">
          <DownloadAppStore className="w-full h-auto" viewBox="0 0 201 44" />
          <span className="sr-only">Download on the App Store</span>
        </Link>
        <Link
          href="https://play.google.com/store/apps/details?id=com.onedebit.chime&hl=en"
          target={LinkTargets.NewTab}
          className="w-full">
          <DownloadGooglePlay className="w-full h-auto" viewBox="0 0 201 44" />
          <span className="sr-only">Get it on Google Play</span>
        </Link>
      </div>
      <div className="flex sm:justify-between max-sm:gap-9 max-w-[170px]">
        <Link href="https://www.facebook.com/chime" target={LinkTargets.NewTab}>
          <FacebookIcon />
          <span className="sr-only">Facebook</span>
        </Link>
        <Link href="https://twitter.com/chime" target={LinkTargets.NewTab}>
          <TwitterIcon />
          <span className="sr-only">X (Twitter)</span>
        </Link>
        <Link href="https://www.instagram.com/Chime/" target={LinkTargets.NewTab}>
          <InstagramIcon />
          <span className="sr-only">Instagram</span>
        </Link>
      </div>
    </div>
  );
};

export default FooterColumnSocial;
